/*Accordion start*/
document.querySelectorAll('.accordion-header').forEach(button => {
  button.addEventListener('click', () => {
    const item = button.parentElement;
    const icon = button.querySelector('.icon');

    item.classList.toggle('active');

    if (item.classList.contains('active')) {
      icon.textContent = "−";
    } else {
      icon.textContent = "+";
    }
  });
});
/*Accordion end*/

/*Shipping start*/
document.addEventListener("DOMContentLoaded", function () {

  const wrap = document.querySelector(".ship-wrap");
  const head = document.querySelector(".ship-head");

  const input = document.querySelector(".ship-input");
  const btn = document.querySelector(".ship-btn");
  const code = document.querySelector(".ship-code");

  const rush = document.querySelector(".rush span");
  const express = document.querySelector(".express span");
  const standard = document.querySelector(".standard span");

  // toggle accordion
  head.addEventListener("click", () => {
    wrap.classList.toggle("active");
  });

  // enable button
  input.addEventListener("input", () => {
    btn.disabled = input.value.length < 4;
  });

  // date function
  function getDate(days) {
    const d = new Date();
    d.setDate(d.getDate() + days);

    return d.toLocaleDateString("en-US", {
      weekday: "long",
      month: "long",
      day: "numeric"
    });
  }

  // set dates
  rush.textContent = getDate(2);
  express.textContent = getDate(5);
  standard.textContent = getDate(12);

  // update ZIP
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    if (input.value) {
      code.textContent = input.value;
    }
  });

});
/*Shipping end*/

const drawer = document.getElementById('sizeDrawer');
const openBtn = document.getElementById('openSizeDrawer');
const closeBtn = document.getElementById('closeDrawerBtn');
const overlay = document.getElementById('closeDrawer');
const addToCartBtn = document.getElementById('addToCartBtn');
const sizeGuideDrawer = document.getElementById('sizeGuideDrawer');
const openSizeGuideBtn = document.getElementById('sizeGuideToggle');
const closeSizeGuideBtn = document.getElementById('closeSizeGuideBtn');
const closeSizeGuideOverlay = document.getElementById('closeSizeGuideDrawer');


let selectedVariantId = null;
openSizeGuideBtn.onclick = () => {
  sizeGuideDrawer.classList.add('active');
};

closeSizeGuideBtn.onclick = closeSizeGuideOverlay.onclick = () => {
  sizeGuideDrawer.classList.remove('active');
};


// Open drawer
openBtn.onclick = () => {
  drawer.classList.add('active');
  document.body.classList.add('no-scroll');
};

// Close drawer
closeBtn.onclick = overlay.onclick = () => {
  drawer.classList.remove('active');
  document.body.classList.remove('no-scroll'); 
};

// Size Guide toggle
// document.getElementById('sizeGuideToggle').onclick = () => {
//   const guide = document.getElementById('sizeGuide');
//   guide.style.display = guide.style.display === 'none' ? 'block' : 'none';
// };

// Variant select
document.querySelectorAll('input[name="variant_id"]').forEach(input => {
  input.addEventListener('change', function () {
    
    selectedVariantId = this.value;
    const available = this.dataset.available === "true";

    document.getElementById('selectedSizeLabel').innerText = this.dataset.title;

    document.querySelectorAll('.variant-item').forEach(item => {
      item.classList.remove('active');
    });

    this.closest('.variant-item').classList.add('active');

    if (available) {
      addToCartBtn.disabled = false;
      addToCartBtn.innerText = "Add to Bag";
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.innerText = "Sold Out";
    }
  });
});

// Add to cart
addToCartBtn.addEventListener('click', () => {
  if (!selectedVariantId) return;

  let formData = {
    items: [{
      id: selectedVariantId,
      quantity: 1
    }]
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(res => res.json())
  .then(data => {
    drawer.classList.remove('active');
    window.location.href = '/cart';
  })
  .catch(err => console.error(err));
});
/*Product varient drawer end*/

